import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-digital-media-marketing',
    templateUrl: './digital-media-marketing.component.html',
    styleUrls: ['./digital-media-marketing.component.scss'],
    standalone: false
})
export class DigitalMediaMarketingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
